// extracted by mini-css-extract-plugin
module.exports = {"box":"box-module--box--1oQjp","boxContent":"box-module--box-content--Ijj5e","boxTitle":"box-module--box-title--3FUhY"};